import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import vlog from '../../javascript/vlog';

function V2RequestLink({ sourceRequestId }) {
  const [v2RequestId, setV2RequestId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const fetchV2Request = async () => {
      try {
        await window.initializeSupabaseClient();
        const { data, error: fetchError } = await window.supabaseClient
          .from('requests')
          .select('id')
          .eq('migrate_id', sourceRequestId)
          .maybeSingle();

        if (fetchError) {
          vlog.error('V2RequestLink: error fetching V2 request:', fetchError);
          setError(true);
          return;
        }

        if (data && data.id) {
          setV2RequestId(data.id);
        } else {
          setNotFound(true);
        }
      } catch (err) {
        vlog.error('V2RequestLink: unexpected error:', err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchV2Request();
  }, [sourceRequestId]);

  if (loading) {
    return <span className="spinner-border spinner-border-sm" role="status" />;
  }

  // Specific request found — link directly to it
  if (v2RequestId) {
    const v2Url = `${window.V2_URL}/admin/requests/${v2RequestId}`;
    return (
      <a href={v2Url} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
        <i className="fa fa-external-link-alt me-1" />
        Open in V2
      </a>
    );
  }

  // Request not migrated to V2 yet
  if (notFound) {
    return <span className="text-muted">Not in V2</span>;
  }

  // V2 unreachable or auth error — fall back to generic V2 admin link
  // so staff always have an escape hatch when V1 actions are disabled
  if (error) {
    return (
      <a href={`${window.V2_URL}/admin/requests`} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
        <i className="fa fa-external-link-alt me-1" />
        Open V2 Admin
      </a>
    );
  }

  return null;
}

V2RequestLink.propTypes = {
  sourceRequestId: PropTypes.number.isRequired,
};

export default V2RequestLink;
